export default {
	liveSaleStarts: 'Live sale starts',
};
